import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, StackView, Typography } from '@telus-uds/components-web';
import queryString from 'query-string';

import { apiHost } from '../utils/request';
import ValidateLoader from '../UI/validateLoader';
import Loading from './loading';

import { ContentWrapper } from '../design/css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ViewSignedContract = ({ location: { search } }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    contractSignature: { header, loadingMessage }
  } = localizedStrings;
  const { id: orderId } = queryString.parse(search);
  const getContractUrl = id => `${apiHost}/orders/${id}/contract-pdf`;

  return !orderId ? (
    <Loading isVisible>
      <ValidateLoader message={loadingMessage} />
    </Loading>
  ) : (
    <>
      <StackView space={4}>
        <Divider />
        <Divider />
      </StackView>
      <div className="container 85%">
        <ContentWrapper>
          <Typography heading="h2" variant={{ size: 'h2' }} block>{header}</Typography>
          <Divider space={2} variant={{ inverse: true }} />
          <embed
            src={getContractUrl(orderId)}
            type="application/pdf"
            width="100%"
            height="600px"
          />
          <Divider space={2} variant={{ inverse: true }} />
        </ContentWrapper>
      </div>
    </>
  );
};

ViewSignedContract.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export default ViewSignedContract;
